export enum RedirectType {
  External = '1',
  Internal = '2',
}

export enum ClientID {
  None = '0',
  SPXInternal = '1',
  SPXSeller = '2',
  SLSInternal = '3',
  SLS = '4',
  Partner = '5', // NOTE: Both Mystock and Shopee Partner uses this, since they use the same partner site
  ShopeePartnerInternal = '6',
  MyStockInternal = '7',
  BrandIpInternal = '8',
  BrandIp = '9',
  OpenPlatformInternal = '10',
  OpenPlatform = '11',
  PartnerVoucherInternal = '12',
  PartnerVoucher = '13',
  SpxAgencyInternal = '14',
  SpxAgency = '15',
  TwsInternal = '16',
  Tws = '17',
  WarehouseManagementSystemInternal = '18',
  WarehouseManagementSystem = '19',
  WorkforceManagementInternal = '20',
  WorkforceManagement = '21',
  WorkforceAgencyInternal = '22',
  WorkforceAgency = '23',
  FmsInternal = '24',
  Fms = '25',
  Sandbox = '26',
  CityLinkExpressInternal = '27',
  CityLinkExpress = '28',
  FoodDriver = '29',
  ServicePoint = '30',
  ServicePointInternal = '31',
  GoogleLoginRedirect = 'GoogleLoginRedirect',
}

export enum URLMatchType {
  ExactMatch = '1',
  HostnameRegex = '2',
  HostnameAndPathnameRegex = '3',
}
